import {
  FieldError,
  FieldPath,
  FieldValues,
  get,
  useFormState,
} from "react-hook-form";
import { ControlHelperTextProps } from "../../control";
import ControlHelperText from "../../control/components/helperText";
import { pathToArray } from "../utils";
import ParentTrigger from "./parentTrigger";

export interface FormErrorProps<TFieldValues extends FieldValues> extends Omit<
  ControlHelperTextProps,
  "error"
> {
  name: FieldPath<TFieldValues> | FieldPath<TFieldValues>[];
  parentControlNames?: FieldPath<TFieldValues> | FieldPath<TFieldValues>[];
}

export default function FormError<TFieldValues extends FieldValues>(
  props: Readonly<FormErrorProps<TFieldValues>>,
) {
  const { name, parentControlNames, ...rest } = props;
  const { errors } = useFormState<TFieldValues>({ name: name });

  const parents = pathToArray(parentControlNames);
  const names = pathToArray(name);

  const messages = names
    .map<(FieldError & { root?: FieldError }) | undefined>((name) =>
      get(errors, name),
    )
    .map((error) => error?.message ?? error?.root?.message)
    .filter((message) => !!message)
    .map((message) => message!);

  return (
    <>
      {!!parents?.length && <ParentTrigger name={names} controls={parents} />}
      {!!messages.length && (
        <ControlHelperText {...rest} error>
          {messages[0]}
        </ControlHelperText>
      )}
    </>
  );
}
